import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { environment } from '../../environments/environment';
import { KeyCodeUtil } from '../infrastructure/keyCode.util';
import { Constant } from '../infrastructure/constant';
import { StorageType, PersistenceService } from 'angular-persistence';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styles: []
})
export class LoginComponent implements OnInit {

  constructor(private authService: AuthService, private messageService: MessageService, protected persistenceService: PersistenceService, private router: Router) { }

  public username: string;
  public password: string;
  public evTitle: string;
  public evName: string;
  public evCompany: string;

  ngOnInit() {
    this.evTitle = environment.title;
    this.evName = environment.name;
    this.evCompany = environment.company;
  }

  async login() {
    //this.authService.login(this.username, this.password);
    const ret = await this.authService.login(this.username, this.password);
    if (ret.isSuccess) {
      const user = ret.data;

      this.persistenceService.set(Constant.auths.userId, user["userId"], { type: StorageType.LOCAL });
      this.persistenceService.set(Constant.auths.userName, user["userName"], { type: StorageType.LOCAL });
      this.persistenceService.set(Constant.auths.fullName, user["userFullName"], { type: StorageType.LOCAL });
      this.persistenceService.set(Constant.auths.datetimeLogin, new Date(), { type: StorageType.LOCAL });
      //
      this.messageService.add({ severity: 'success', detail: 'Đăng nhập thành công.' });
      this.persistenceService.set(Constant.auths.isLoginIn, 'true', { type: StorageType.LOCAL });
      this.persistenceService.set(Constant.auths.token, user["token"], { type: StorageType.LOCAL });

      const routing = "";
      this.router.navigate([routing]);
    } else {
      this.messageService.add({ severity: 'warn', detail: 'Đăng nhập không thành công.' });
    }
  }

  keyDownFunction(event) {
    if ((event.ctrlKey || event.metaKey) && event.which === KeyCodeUtil.charS) {
      this.login();
      event.preventDefault();
      return false;
    }
  }
}



// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/login/login.component.ts